
import { useLoading } from "../../Context/LoadingContext";
import NotificationCenter from "../../notifications/NotificationCenter";
const Header=()=>{ 
   const { 
  CurrentTime
} = useLoading();
    return <>
      <header className="fixed top-0 right-[280px] left-0 h-16 bg-surface/80 backdrop-blur-xl shadow-[0_1px_8px_rgba(0,0,0,0.04)] z-40 flex items-center px-8 justify-between">
      <div className="flex items-center bg-surface-container-high px-4 py-2 rounded-full w-96 gap-2">
        <span className="material-symbols-outlined text-on-surface-variant">
          search
        </span>
        <input
          className="bg-transparent border-none focus:ring-0 text-body-sm w-full outline-none text-on-surface"
          placeholder="بحث..."
          type="text"
        />
      </div>
      <div className="flex items-center gap-6">
         <button className="relative p-2 rounded-full hover:bg-surface-container-high transition-colors">
          <span className="material-symbols-outlined text-on-surface-variant">
            timer_off
          </span>
          {CurrentTime()} 
        </button> 
        <button className="relative p-2 rounded-full hover:bg-surface-container-high transition-colors">
          <span className="material-symbols-outlined text-on-surface-variant">
            notifications
           
          </span>
          <span className="absolute top-2 left-2 w-2 h-2 bg-vibrant-orange rounded-full" />
        </button>
        <div className="flex items-center gap-3 pl-4 border-l border-outline-variant">
          <div className="text-left flex flex-col items-end">
            <span className="font-label-md text-on-surface">{localStorage.getItem("user-server")}  </span>
            <span className="text-[10px] text-on-surface-variant">
              مسؤول النظام
           
            </span>
          </div>
            <a href="/admin/login"  className="relative p-2 rounded-full hover:bg-surface-container-high transition-colors">
          <span className="material-symbols-outlined text-on-surface-variant">
            logout
          </span>
          <span className="absolute top-2 left-2 w-2 h-2 bg-vibrant-orange rounded-full" />
        </a>
        </div>
      </div>
    </header>
    </>
}
export default Header;